// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-spin input[type=number]{-moz-appearance:textfield}.shadow-row.v-data-table>.v-data-table__wrapper>table{border-spacing:0 16px!important}.shadow-row.v-data-table>.v-data-table__wrapper>table>tbody>tr{box-shadow:3px 5px 6px -4px rgba(0,0,0,.8)}", ""]);
// Exports
module.exports = exports;
